export default __webpack_public_path__ + "static/media/overview-express.98e37358.jpg";